import { TextField } from '@mui/material';

export type PlaceOfDeathInputProps = {
  value: string | null;
  onChange: (value: string | null) => void;
  label: string;
};

export function PlaceOfDeathInput({
  value,
  onChange,
  label,
}: PlaceOfDeathInputProps) {
  return (
    <TextField
      type='text'
      label={label}
      size='small'
      value={value}
      onChange={event =>
        onChange(event.target.value === '' ? null : event.target.value)
      }
      fullWidth
    />
  );
}
